module.exports = __webpack_public_path__ + "static/media/10.jpg.b49a868a.webp";